
import { defineComponent } from "vue";
import OnlineHero from "@/components/online/OnlineHero.vue";
import PageContainer from "@/components/PageContainer.vue";
import PageTitle from "@/components/PageTitle.vue";
import PageContent from "@/components/PageContent.vue";
import PostsBlock from "@/components/PostsBlock.vue";
import FollowFestival from "@/components/FollowFestival.vue";

export default defineComponent({
  components: {
    OnlineHero,
    PageContainer,
    PageTitle,
    PageContent,
    PostsBlock,
    FollowFestival,
  },
});
